/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from "../../icetypes";
import { encounterprogressnotesreference } from '../../ehr/subs/encounterprogressnotesreference';
import { diagnosisreference } from '../../ehr/subs/diagnosisreference';
import { medicalservicereference } from './medicalservicereference';

export class superbillcharges extends IceEntity {
  superbill_charges_key: string = "";
  subscriber_key: string = "";
  superbill_key: string = "";
  referral_from_key: string = "";
  from_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone; // new
  from_trans_account: string = "";
  to_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone; // new
  to_trans_account: string = "";
  statement_note: string = "";
  total: number = 0.0;
  signature: string = "";
  signature_date: any = NaN;
  doctor_signature: string = "";
  doctor_signature_date: any = NaN;
  bill_status: IceTypes.trans_status = IceTypes.trans_status.isNone; // new 
  diagnosis_submitted: boolean = false;
  cfield_data: string = "";
  diagnosis_note: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";
  bill_to: string = "";

  CHARGES: medicalservicereference[] = [];
  DIAGS: diagnosisreference[] = [];
  NOTES: encounterprogressnotesreference[] = [];

  constructor() {
    super();
  }

  gettablename(): string {
  return "SUPERBILL_CHARGES";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "CHARGES") return true;
    else if (ColumnName == "CFIELD_DATA") return true;
    else if (ColumnName == "DIAGS") return true;
    else if (ColumnName == "NOTES") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "CHARGES") return "MEDICAL_SERVICE_REFERENCE";
    else if (ColumnName == "CFIELD_DATA") return "OTHER_ITEMS_RECEIVING";
    else if (ColumnName == "DIAGS") return "DIAGNOSIS_REFERENCE";
    else if (ColumnName == "NOTES") return "ENCOUNTER_PROGRESS_NOTES_REFERENCE";

    return null;
  }
}
